/** @format */

import {SaveSpace, Space} from 'pages/Home/DigitalCast/models/spaces';

interface Options extends SaveSpace {
  space: Space;
  value: string;
}

const updateSpaceTitle = ({space, value, saveSpaceSettings}: Options): Space => {
  const trimmedValue = value.trim();

  if (space.title === trimmedValue) {
    return space;
  }

  const result: Space = {
    ...space,
    title: trimmedValue,
  };

  saveSpaceSettings(result);

  return result;
};

export default updateSpaceTitle;
